import { request } from '../utils/request'
// import { querystring } from '../utils/index'

export default {
  getproductstats: option =>
    request('v1/stats/getproductstats', option, true, false), // 商品统计
  getscantagstats: option =>
    request('v1/stats/getscantagstats', option, true, false), // 扫码量统计
  getinventorys: option =>
    request('v1/inventory/getinventorys', option, true, false), // 库存统计
  suminventoryinout: option =>
    request('v1/inventory/suminventoryinout', option, true, false), // chuku统计
  getinventoryinouttrend: option =>
    request('v1/inventory/getinventoryinouttrend', option, true, false), // 库存出库统计
  sumstocksafety: option =>
    request('v1/inventory/sumstocksafety', option, true, false), // 库存出库统计
  sumordertrend: option =>
    request('v1/orderstats/sumordertrend', option, true, false), // 订单统计
  sumproducttrading: option =>
    request('v1/orderstats/sumproducttrading', option, true, false), // 商品交易统计
  sumcustomertrading: option =>
    request('v1/orderstats/sumcustomertrading', option, true, false) // 商品交易统计
}
